// Dados e formatação das notícias compartilhados entre a Home e a listagem

// Abas fixas nas pontas; as categorias do meio vêm de `news-categories`
// `Geral` agrupa as notícias sem categoria, como a editoria genérica dos portais de notícia
export const ALL_TAB = { key: `all`, label: `Todas` }
export const UNCATEGORIZED_TAB = { key: `none`, label: `Geral` }
export const DEFAULT_TABS = [ALL_TAB, UNCATEGORIZED_TAB]

// Página da listagem no CMS (sem o locale); se o slug mudar lá, muda só aqui
export const NEWS_LIST_PATH = `comunicacao/noticias`

const MONTHS = [`janeiro`, `fevereiro`, `março`, `abril`, `maio`, `junho`, `julho`, `agosto`, `setembro`, `outubro`, `novembro`, `dezembro`]

export default {
	methods: {
		fetchNewsTabs() {
			return this.$axios
				.get(`news-categories`)
				.then(response => [
					ALL_TAB,
					...response.data.map(category => ({ key: String(category.id), label: category.name })),
					UNCATEGORIZED_TAB,
				])
				.catch(() => DEFAULT_TABS)
		},
		// Valor de `categoryId` para a aba: `null` busca só as notícias sem categoria
		categoryParam(tabKey) {
			if (tabKey === UNCATEGORIZED_TAB.key)
				return `null`
			const id = Number.parseInt(tabKey)
			return Number.isInteger(id) ? id : undefined
		},
		// Notícia sem slug não tem para onde levar e fica de fora
		parseNewsList(list) {
			return (list || []).map(this.parseNews).filter(news => news.slug)
		},
		parseNews(news) {
			const translation = (news.translations || [])[0] || {}
			return {
				id: news.id,
				title: translation.title,
				description: translation.description,
				slug: translation.slug,
				publishedAt: translation.publishedAt,
				thumb: translation.thumb ? translation.thumb.filePath : ``,
				category: news.category ? news.category.name : UNCATEGORIZED_TAB.label,
			}
		},
		newsRoute(news) {
			return { name: `Noticia`, params: { slug: news.slug, locale: this.$store.state.locale } }
		},
		formatDate(date) {
			const value = date ? new Date(date) : null
			// Data malformada vira `Invalid Date`, e o `formatToParts` lançaria `RangeError`
			if (!value || Number.isNaN(value.getTime()))
				return ``
			const parts = new Intl.DateTimeFormat(`pt-BR`, {
				day: `2-digit`,
				month: `numeric`,
				year: `numeric`,
				timeZone: `America/Sao_Paulo`,
			}).formatToParts(value)
			const part = type => parts.find(item => item.type === type).value
			return `${part('day')} de ${MONTHS[part('month') - 1]}, ${part('year')}`
		},
	},
}
